var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Indicator / Heart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Awards-&-Illustrations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Indicator-/-Heart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg-heart-icon-2",
    transform: "translate(19.000000, 22.000000)",
    fillRule: "nonzero",
    fill: "#27BF5B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(0.468085, 0.021277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.52659574,14.4893617 L1.72340426,9.68617021 C-0.478723404,7.48404255 -0.478723404,3.89361702 1.72340426,1.69148936 L1.72340426,1.69148936 C3.92553191,-0.510638298 7.51595745,-0.510638298 9.71808511,1.69148936 L14.5212766,6.49468085 C16.7234043,8.69680851 16.7234043,12.287234 14.5212766,14.4893617 L14.5212766,14.4893617 C12.3351064,16.6755319 8.7287234,16.6755319 6.52659574,14.4893617 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52659574,6.49468085 L11.3297872,1.69148936 C13.5319149,-0.510638298 17.1223404,-0.510638298 19.3244681,1.69148936 L19.3244681,1.69148936 C21.5265957,3.89361702 21.5265957,7.48404255 19.3244681,9.68617021 L14.5212766,14.4893617 C12.3191489,16.6914894 8.7287234,16.6914894 6.52659574,14.4893617 L6.52659574,14.4893617 C4.34042553,12.287234 4.34042553,8.68085106 6.52659574,6.49468085 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97340426,17.9202128 L5.69680851,13.643617 C5.39361702,13.3404255 5.39361702,12.8297872 5.69680851,12.5106383 L9.97340426,8.23404255 C10.2765957,7.93085106 10.787234,7.93085106 11.106383,8.23404255 L15.3829787,12.5106383 C15.6861702,12.8138298 15.6861702,13.3244681 15.3829787,13.643617 L11.106383,17.9202128 C10.787234,18.2234043 10.2765957,18.2234043 9.97340426,17.9202128 Z",
    id: "Shape"
  })))), /*#__PURE__*/React.createElement("polyline", {
    id: "Page-1",
    stroke: "#FEFEFE",
    strokeWidth: 0.833,
    strokeLinejoin: "round",
    points: "13.5 30.5721183 25.1163508 30.5721183 27.5747367 26.1304788 29.9684283 34.8695212 32.7603614 28.346526 34.9774692 30.2311472 46.9883495 30.2311472"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.e745c8e36d684256b51c5fc7e74811f8.svg";
export { ForwardRef as ReactComponent };